// File: SearchBarFields.ts
import $ from "jquery";

import { SheetHelper } from './sheetHelper';
import { ButtonHelper } from './../common/buttonHelper';
import { SearchRoomManager } from '../common/searchRoomManager';

let searchTimeout: number | undefined;
export interface SearchBarFieldsOptions {
    desktopBreakpoint?: number;
    isTransfer?: boolean;
}

export function initSearchBarFields(options?: SearchBarFieldsOptions) {
    const desktopBreakpoint = options?.desktopBreakpoint ?? 992;
    const searchInput = document.getElementById('SearchBarForm_SearchLocation') as HTMLInputElement | null;
    const locationDisplay = document.getElementById('locationDisplay') as HTMLInputElement | null;

    if (searchInput && locationDisplay && searchInput.value.trim() !== '') {
        locationDisplay.innerHTML = searchInput.value;
    }

    document.querySelectorAll<HTMLElement>('[data-sheet-content]').forEach(trigger => {
        const sheetSelector = trigger.getAttribute('data-sheet-content');
        if (!sheetSelector) return;

        const sheet = document.querySelector<HTMLElement>(sheetSelector);
        if (!sheet) return;

        const mobileParent = sheet.parentElement!;
        const desktopContainer = document.createElement("div");
        desktopContainer.className = "desktop-dropdown-container";

        if (options?.isTransfer) {
            const searchBar = document.getElementById('SearchBar') as HTMLInputElement | null;
            if (searchBar) {
                searchBar.appendChild(desktopContainer);
            }
        }
        else {
            trigger.appendChild(desktopContainer);
        }

        function updateDropdownPosition() {
            requestAnimationFrame(() => {
                const isDesktop = window.innerWidth >= desktopBreakpoint;

                if (isDesktop) {
                    if (sheet!.parentElement !== desktopContainer) desktopContainer.appendChild(sheet!);
                    const rect = trigger.getBoundingClientRect();
                    sheet!.style.position = "relative";

                    if (sheet!.classList.contains("show")) {
                        desktopContainer.style.display = "block";
                        desktopContainer.style.position = "absolute";
                        desktopContainer.style.zIndex = "6000";
                        desktopContainer.style.top = (options?.isTransfer) ? `80px` : `40px`;
                        desktopContainer.style.left = `0px`;
                    } else {
                        desktopContainer.style.display = "none";
                        desktopContainer.style.zIndex = "0";
                        desktopContainer.style.top = `-${rect.bottom + window.scrollY + 10}px`;
                        desktopContainer.style.left = `-${rect.left + window.scrollX}px`;
                    }

                    sheet!.style.minWidth = `${rect.width}px`;
                    sheet!.style.width = "auto";
                    sheet!.style.height = "auto";
                    sheet!.style.bottom = "auto";
                } else {
                    if (sheet!.parentElement !== mobileParent) mobileParent.appendChild(sheet!);

                    sheet!.style.position = "fixed";
                    sheet!.style.left = "0";
                    sheet!.style.width = "100vw";
                    sheet!.style.minWidth = "100vw";

                    if (sheet!.classList.contains("full-screen")) {
                        sheet!.style.top = "0";
                        sheet!.style.height = `${window.innerHeight}px`;
                    } else {
                        sheet!.style.top = "auto";
                        sheet!.style.height = sheet!.classList.contains("one-third-screen")
                            ? "55vh"
                            : "80vh";
                    }

                    sheet!.style.bottom = sheet!.classList.contains("show") ? "0" : "-100%";
                }
            });
        }

        updateDropdownPosition();

        // --- NEW: Handle breakpoint snapping ---
        let wasDesktop = window.innerWidth >= desktopBreakpoint;

        window.addEventListener("resize", () => {
            const isDesktop = window.innerWidth >= desktopBreakpoint;
            if (isDesktop !== wasDesktop) {
                wasDesktop = isDesktop;
                updateDropdownPosition();
            }
        });

        // Example max rooms
        const maxRooms = 5;

        // Create instance
        const searchRoomManager = new SearchRoomManager(maxRooms);

        // Trigger click to open sheet
        trigger.addEventListener("click", (e) => {
            //e.stopPropagation();
            const target = e.target as HTMLElement;
            var childAgeVerifySuccess = searchRoomManager.validateChildAges();

            // 🧠 Ignore clicks inside any close button or search option inside the sheet
            if (target.closest(".close-popover")) {
                e.stopPropagation();

                if (childAgeVerifySuccess) {
                    // Close other sheets
                    SheetHelper.closeAllSheets();
                }

                return;
            }

            // 🧠 Ignore clicks inside the sheet itself
            if (target.closest(".db-sheet")) {
                //e.stopPropagation();
                return; // do nothing if clicking inside the sheet
            }

            if (childAgeVerifySuccess) {
                // Close other sheets
                SheetHelper.closeAllSheets();

                // Toggle current sheet
                SheetHelper.toggleSheet(sheet);

                updateDropdownPosition();
            }



        });

        // Delegated close buttons
        document.body.addEventListener("click", (e) => {
            const btn = (e.target as HTMLElement).closest(".close-popover, .search-option");
            if (btn) {
                // Initialise event handlers
                var childAgeVerifySuccess = searchRoomManager.validateChildAges();

                if (childAgeVerifySuccess) {
                    SheetHelper.closeAllSheets();
                    updateDropdownPosition();
                }
            }
        });

        // Close all sheets when clicking outside
        document.addEventListener("click", (e) => {
            const target = e.target as HTMLElement;

            // If has an ignore-close class then, ignore! 
            if (target.classList.contains("ignore-close")) return;

            // If click is inside any open sheet, ignore
            if (target.closest(".db-sheet.show")) return;

            // If click is on a trigger that opens a sheet, ignore
            if (target.closest("[data-sheet-content]")) return;

            // If click is inside the min nights/max nights/check out only modal, ignore it
            if (target.closest("#minNightsModal") || target.closest("#minNightsModal") || target.closest("#checkOutOnlyModal")) return;

            // Initialise event handlers
            var childAgeVerifySuccess = searchRoomManager.validateChildAges();

            if (childAgeVerifySuccess) {
                // Otherwise, close all open sheets
                SheetHelper.closeAllSheets();
                updateDropdownPosition();
            }
        });
    });

    $(document).on('click', '#btnSubmitSearch, #btnSubmitInfoSearch', function (e: JQuery.ClickEvent) {
        e.preventDefault();

        const isMainSearchButton = this.id === 'btnSubmitSearch';

        if (isMainSearchButton) {
            const searchId = $('.search-id').val() as string | null;

            if (searchId === null || searchId === '') {
                if ($('.search-suggestions .search-option').length !== 0) {
                    $('.search-suggestions .search-option').first().trigger('click');
                } else {
                    $('.search-trending .search-option').first().trigger('click');
                }
            }
        }

        const maxRooms = 5;

        // Create instance
        const searchRoomManager = new SearchRoomManager(maxRooms);

        var childAgeVerifySuccess = searchRoomManager.validateChildAges();
        if (childAgeVerifySuccess) {
            // CONTINUE SUBMISSION OF FORM
            $(this).closest('form').submit();
        } else {
            ButtonHelper.resetSpinnerButtons();

            const roomsSheet = document.querySelector<HTMLElement>("#roomsSheetContent");
            if (roomsSheet) {
                SheetHelper.toggleSheet(roomsSheet);
            }
        }
    });
}

// Function to handle "search-option" selection
export function initSearchOptionClick(): void {
    document.addEventListener("click", (e: Event) => {
        const target = e.target as HTMLElement | null;
        const option = target?.closest<HTMLElement>(".search-option");
        if (!option) return;

        const searchId = option.dataset.searchId;
        const searchType = option.dataset.searchType;
        const displayName = option.dataset.displayName;

        if (!searchId || !searchType || !displayName) return;

        (document.getElementById("SearchBarForm_SearchId") as HTMLInputElement).value = searchId;
        (document.getElementById("SearchBarForm_SearchType") as HTMLInputElement).value = searchType;
        (document.getElementById("locationSearchBar") as HTMLInputElement).value = displayName;
        document.querySelectorAll<HTMLInputElement>(".mobile-location-search-bar").forEach(el => (el.value = displayName));

        const locationDisplay = document.getElementById("locationDisplay");
        if (locationDisplay) locationDisplay.innerHTML = displayName;

        $('#locationSearchBar').blur();

        $('.btn-empty-search-location').removeClass('hidden');

        // Close any open sheets after selection
        SheetHelper.closeAllSheets();
    });

    // Clear a Drop Down Option
    $(document).on('click', '.btn-empty-search-location', function (e) {
        $('#locationSearchBar').val('');
        $('.mobile-location-search-bar').val('');
        $('#locationSearchBar').trigger('keyup');
        $('#locationDisplay').html(window._screenMessages.SearchLocationPlaceholder);
        $('#locationSearchBar').focus();
        $('.search-id').val('');
        $(this).addClass('hidden');
    });
}

export function initMobileSearchbarToggle() {
    const placeholder = document.querySelector<HTMLElement>(".db-searchbar-mobile-placeholder");
    const realSearchbar = document.querySelector<HTMLElement>(".db-searchbar");
    const overlay = document.querySelector<HTMLElement>(".searchbar-overlay");

    if (!placeholder || !realSearchbar || !overlay) return;

    const openSearchBar = () => {
        // Step 1: show overlay
        overlay.classList.add("active");

        // Step 2: make searchbar visible
        //realSearchbar.classList.remove("db-searchbar-list");

        // Step 3: measure placeholder
        const rect = placeholder.getBoundingClientRect();

        // Step 4: set starting position
        realSearchbar.style.top = `${rect.top + window.scrollY}px`;
        realSearchbar.classList.add("from-placeholder");

        // Force reflow
        void realSearchbar.offsetWidth;

        // Step 5: trigger animation to final state
        realSearchbar.classList.add("active");
        realSearchbar.classList.remove("from-placeholder");

        // Step 6: cleanup inline style after transition
        setTimeout(() => {
            realSearchbar.style.top = "95px"; // your final top value
        }, 200);
    };

    const closeSearchBar = () => {
        overlay.classList.remove("active");
        realSearchbar.classList.remove("active");
        realSearchbar.style.removeProperty("top");
        //realSearchbar.classList.add("db-searchbar-list");
    };

    // Open on mobile placeholder click
    placeholder.addEventListener("click", openSearchBar);

    // Close on overlay click
    overlay.addEventListener("click", closeSearchBar);

    // close on window resize
    window.addEventListener("resize", closeSearchBar);
}

export function initSearchDropdownHandler(): void {
    // Retain Search Location from Previous Search
    const searchLocation = $('#SearchBarForm_SearchLocation').val() as string | null;

    if (searchLocation !== null && searchLocation !== '') {
        $('#locationSearchBar').val(searchLocation);
        $('#locationDisplay').html(searchLocation);
        $('.btn-empty-search-location').removeClass('hidden');
        $('#locationSearchBar').trigger('keyup');
    }

    // Click the location box
    $(document).on('click', '#location', function (e: JQuery.ClickEvent) {
        // If element has read-only class, block everything
        if ($(this).hasClass('read-only')) {
            //e.preventDefault();
            //e.stopImmediatePropagation();
            return;
        }

        if (($(window).width() ?? 0) > 768) {
            $("#locationSearchBar").removeClass("hidden");
            $("#locationDisplay").addClass("hidden");
            $("#locationSearchBar").focus();
        } else {
            $("#mobileLocationSearchBar").focus();
        }
    });

    // Search Drop Down Event Handler
    $('#locationSearchBar').on('keyup', function (e: JQuery.KeyUpEvent) {
        const text = $(this).val() as string;
        $('.mobile-location-search-bar').val(text);

        const token = $('input[name="__RequestVerificationToken"]').val() as string;

        if (text.length === 0) {
            $('.search-suggestions').html('');
            $('.search-trending').removeClass('hidden');
            $('.international-ad').removeClass('hidden');
            $('.btn-empty-search-location').addClass('hidden');
        }
        else if (text.length >= 3) {
            $('.btn-empty-search-location').removeClass('hidden');
            $('.search-trending').addClass('hidden');
            $('.international-ad').addClass('hidden');

            $.ajax({
                url: '/Search/SearchLocationAutoComplete',
                type: 'POST',
                data: {
                    '__RequestVerificationToken': token,
                    'Prefix': text
                },
                success: function (data) {
                    $('.search-suggestions').html(data);
                },
                error: function (xhr, status) {
                    console.log(xhr);
                    console.log(status);
                }
            });
        }
    });

    $(document).on("keyup", ".mobile-location-search-bar", function (e: JQuery.KeyUpEvent) {
        const text: string = ($(this).val() as string) ?? "";

        $("#locationSearchBar").val(text);
        $("#locationDisplay").html(text);

        const token: string = ($('input[name="__RequestVerificationToken"]').val() as string) ?? "";

        if (text.length === 0) {
            $(".search-suggestions").html("");
            $(".search-trending").removeClass("hidden");
            $('.international-ad').removeClass('hidden');
            $(".btn-empty-search-location").addClass("hidden");
            return;
        }

        if (text.length >= 3) {
            $(".btn-empty-search-location").removeClass("hidden");
            $(".search-trending").addClass("hidden");
            $('.international-ad').addClass('hidden');

            // Clear any previous timer
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }

            // Debounce: wait 300ms after typing stops
            searchTimeout = window.setTimeout(() => {
                $.ajax({
                    url: "/Search/SearchLocationAutoComplete",
                    type: "POST",
                    data: {
                        __RequestVerificationToken: token,
                        Prefix: text
                    },
                    success: (data: string) => {
                        $(".search-suggestions").html(data);
                    },
                    error: (xhr: JQuery.jqXHR, status: string) => {
                        console.log(xhr);
                        console.log(status);
                    }
                });
            }, 300);
        }
    });
}

export function initHotelChangeSearch(): void {

    const elementIds = ['hotelCalendarDisplay', 'hotelGuestsDisplay'];
    const classNameToAdd = 'pulse';

    const observer = new MutationObserver((mutations) => {
        const updateButton = (id: string) => {
            const button = document.getElementById(id);
            if (button && !button.classList.contains(classNameToAdd)) {
                button.classList.add(classNameToAdd);
                button.innerHTML = `<i class="fa-solid fa-arrows-rotate"></i> ` + window._screenMessages.ApplyChanges;
            }
        };

        if (mutations.some(m => {
            const target = m.target as HTMLElement;
            return target.id && elementIds.includes(target.id);
        })) {
            updateButton('btnSubmitHotelChangeSearch');
            updateButton('btnSubmitPackageDealChangeSearch');
        }
    });

    const config: MutationObserverInit = {
        childList: true,
        characterData: true,
        subtree: true
    };

    // Start observing both span elements
    for (const id of elementIds) {
        const el = document.getElementById(id);
        if (el) observer.observe(el, config);
    }

    $(document).on('click', '#btnSubmitHotelChangeSearch', function (e: JQuery.ClickEvent) {
        e.preventDefault();

        // Remember to scroll after reload
        sessionStorage.setItem('scrollToAvailability', 'true');

        // Collect form values
        const s = $('#SearchBarForm_SearchId').val()
        const ad = $('#SearchBarForm_ArrivalDate').val();
        const nn = $('#SearchBarForm_NumberOfNights').val();
        const ri = $('#SearchBarForm_RoomInfoString').val();
        const rc = $('#SearchBarForm_RateCodeSlug').val();

        // Construct the query string
        const queryParams = new URLSearchParams();
        if (s) queryParams.set('s', s as string);
        if (ad) queryParams.set('ad', ad as string);
        if (nn) queryParams.set('nn', nn as string);
        if (ri) queryParams.set('ri', ri as string);
        if (rc) queryParams.set('rc', rc as string);

        // Redirect
        window.location.href = `/Hotel?${queryParams.toString()}`;
    });

    $(document).on('click', '#btnSubmitPackageDealChangeSearch', function (e: JQuery.ClickEvent) {
        e.preventDefault();

        // Remember to scroll after reload
        sessionStorage.setItem('scrollToAvailability', 'true');

        // Collect form values
        const s = $('#SearchBarForm_HotelSlug').val()
        const pdid = $('#SearchBarForm_PackageDealId').val();
        const ad = $('#SearchBarForm_ArrivalDate').val();
        const nn = $('#SearchBarForm_NumberOfNights').val();
        const ri = $('#SearchBarForm_RoomInfoString').val();
        const rc = $('#SearchBarForm_RateCodeSlug').val();

        // Construct the query string
        const queryParams = new URLSearchParams();
        if (s) queryParams.set('s', s as string);
        if (pdid) queryParams.set('pdid', pdid as string);
        if (ad) queryParams.set('ad', ad as string);
        if (nn) queryParams.set('nn', nn as string);
        if (ri) queryParams.set('ri', ri as string);
        if (rc) queryParams.set('rc', rc as string);

        // Redirect
        window.location.href = `/PackageDeal/Info?${queryParams.toString()}`;
    });
}